<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.dateRange}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs6>
                          <v-select v-model="reportForm.tranType" :items="tranTypeList" :label="labels.tranType" item-text="label" item-value="value" />
                        </v-flex>
                        <v-flex xs12 sm12 md12 lg12>
                          <form ref="CSVForm">
                            <input type="file" style="display: none" ref="CSVfile" accept=".csv" @change="doValidateFile" />
                          </form>
                          <v-text-field
                            readonly
                            v-model="requestedFile"
                            :label="labels.requestedFile"
                            :error-messages="errors.collect('requestedFile')"
                            data-vv-name="requestedFile"
                            :data-vv-as="labels.requestedFile"
                            append-icon="mdi-magnify"
                            @click:append="pickFile"
                            v-validate="'required'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> {{labels.selectionCriteria}}
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="reportForm.acctPeriodFrom"
                            :label="labels.acctPeriodFrom"
                            :error-messages="errors.collect('acctPeriodFrom')"
                            :data-vv-as="labels.acctPeriodFrom"
                            data-vv-name="acctPeriodFrom"
                            append-icon="mdi-magnify"
                            :loading="loading"
                            v-validate="acctPeriodFromValidation"
                            @click:append="showAcctPeriodHelpListFrom = true"
                            clearable
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6>
                          <v-text-field
                            v-model="reportForm.acctPeriodTo"
                            :label="labels.acctPeriodTo"
                            :error-messages="errors.collect('acctPeriodTo')"
                            :data-vv-as="labels.acctPeriodTo"
                            data-vv-name="acctPeriodTo"
                            append-icon="mdi-magnify"
                            :loading="loading"
                            v-validate="acctPeriodToValidation"
                            @click:append="showAcctPeriodHelpListTo = true"
                            clearable
                          ></v-text-field>
                        </v-flex>
                      </v-layout>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12 v-if="reportForm.tranType === 'premBill'">
          <v-expansion-panels v-model="panel3" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-layout row wrap>
                  <v-flex xs12 md6>
                          <v-text-field
                            v-model="reportForm.interType"
                            :label="labels.interType"
                            :error-messages="errors.collect('reportForm.interType')"
                            :data-vv-as="labels.interType"
                            data-vv-name="reportForm.interType"
                            readonly
                          >
                            <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                              <v-icon color="info" @click="showInterTypeHelpList = true">mdi-magnify</v-icon>
                            </v-slide-x-reverse-transition>
                          </v-text-field>
                        </v-flex>
                </v-layout>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showAcctPeriodHelpListFrom" width="1280px">
      <acct-period-help-list
        @close="showAcctPeriodHelpListFrom = false"
        @assign-acct-period-info="assignAcctPeriodFrom"
        :boolRefresh="showAcctPeriodHelpListFrom"
        :modeNo="modeNo"
      ></acct-period-help-list>
    </v-dialog>
    <v-dialog v-model="showAcctPeriodHelpListTo" width="1280px">
      <acct-period-help-list
        @close="showAcctPeriodHelpListTo = false"
        @assign-acct-period-info="assignAcctPeriodTo"
        :boolRefresh="showAcctPeriodHelpListTo"
        :modeNo="modeNo"
      ></acct-period-help-list>
    </v-dialog>
    <v-dialog v-model="showInterTypeHelpList" width="900px" persistent>
      <multi-intermediary-type-help-list
        :interType="reportForm.interType"
        @close="showInterTypeHelpList = false"
        @doAssign="doAssign('interType', $event)"
      ></multi-intermediary-type-help-list>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import AcctPeriodHelpList from '@/components/core/common/dialog/AcctPeriodHelpList'
import MultiIntermediaryTypeHelpList from '@/components/core/common/dialog/MultiIntermediaryTypeHelpList.vue'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      labels: {
        dateRange: '',
        tranDateFrom: 'From Transaction Date*',
        tranDateTo: 'To Transaction Date*',
        acctPeriodFrom: 'Account Period From',
        acctPeriodTo: 'Account Period To',
        tranType: 'Type of Transactions',
        requestedFile: 'Upload UOB Name List',
        selectionCriteria: 'Selection Criteria',
        export: 'Export To',
        format: 'XLSX',
        pbPrtParam: 'Print Run Time Parameters',
        interType: 'Intermediary Types'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        acctPeriodFrom: '',
        acctPeriodTo: '',
        acctPerMthFrom: '',
        acctPerYrFrom: '',
        acctPerMthTo: '',
        acctPerYrTo: '',
        tranType: 'premBill',
        interType: 'All',
        format: undefined,
        pbPrtParam: true
      },
      requestedFile: '',
      loading: false,
      supportedFormat: ['XLSX'],
      agentHelpList: false,
      helpListTitle: 'Billing Agent(s) Helplist',
      intrGrp: '10,11,12,20,25',
      showErrorDialog: false,
      allSelectedList: [
        {
          label: 'All',
          value: 'All'
        },
        {
          label: 'Selected',
          value: 'Selected'
        }
      ],
      tranTypeList: [
        { label: 'Premium Billed', value: 'premBill' },
        { label: 'Claims Paid', value: 'clmPaid' }
      ],
      panel1: [0],
      panel2: [0],
      panel3: [0],
      showAcctPeriodHelpListFrom: false,
      showAcctPeriodHelpListTo: false,
      showInterTypeHelpList: false,
      modeNo: '3'
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else if (this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== undefined) {
        return 'required'
      } else {
        return ''
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else if (this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== undefined) {
        return 'required'
      } else {
        return ''
      }
    },
    acctPeriodFromValidation() {
      if (this.reportForm.acctPeriodTo !== '' && this.reportForm.acctPeriodTo !== null) {
        return 'required'
      } else {
        return ''
      }
    },
    acctPeriodToValidation() {
      if (this.reportForm.acctPeriodFrom !== '' && this.reportForm.acctPeriodFrom !== null) {
        return 'required'
      } else {
        return ''
      }
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.directorRelationship
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
          // this.getPolTypeList()
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    pickFile() {
      this.$refs.CSVForm.reset()
      this.$refs.CSVfile.click()
    },
    async getFile(event) {
      this.file = event.target.files[0]
    },
    async doUpload(event) {
      await this.getFile(event)
    },
    doValidateFile(e) {
      this.requestedFile = ''
      this.resetMessages()
      if (e.target.files[0]) {
        const file = e.target.files[0]
        if (file.name.indexOf('.csv') !== -1) {
          this.requestedFile = file.name
          const fileReader = new FileReader()
          fileReader.readAsText(file)
        } else {
          this.$toast.error('Please Select CSV File (.csv) Only!')
        }
      }
      this.doUpload(e)
    },
    doClose() {
      this.agentHelpList = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport(event) {
      const apiURI = this.menu.upload
      // const apiURI2 = this.menu.doExport
      if (apiURI) {
        try {
          if (this.reportForm.acctPeriodFrom == null) {
            this.reportForm.acctPeriodFrom = ''
          }
          if (this.reportForm.acctPeriodTo == null) {
            this.reportForm.acctPeriodTo = ''
          }
          if (this.reportForm.acctPerMthFrom == null) {
            this.reportForm.acctPerMthFrom = ''
          }
          if (this.reportForm.acctPerYrFrom == null) {
            this.reportForm.acctPerYrFrom = ''
          }
          if (this.reportForm.acctPerMthTo == null) {
            this.reportForm.acctPerMthTo = ''
          }
          if (this.reportForm.acctPerYrTo == null) {
            this.reportForm.acctPerYrTo = ''
          }
          this.loading = true
          let formData = new FormData()
          formData.append('file', this.file)
          formData.append('form', new Blob([JSON.stringify(this.reportForm)], { type: 'application/json' }))
          const result = await this.$http.post(apiURI, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          const { data } = result
          if (data) {
            this.$toast.success('Job successfully scheduled.')
            this.requestedFile = ''
            // if (data.) {
            //   this.$toast.success('Job successfully scheduled.')
            // } else {
            //   this.$toast.success('Generating reports.')
            // }
            // this.fetchBatchJobs()
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.showErrorDialog = true
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList() {
      this.agentHelpList = true
    },
    assignAcctPeriodFrom(data) {
      this.resetValidator()
      this.resetMessages()
      this.reportForm.acctPeriodFrom = data.acctPerMth + ' / ' + data.acctPerYr
      this.reportForm.acctPerMthFrom = data.acctPerMth
      this.reportForm.acctPerYrFrom = data.acctPerYr
      this.showAcctPeriodHelpListFrom = false
    },
    assignAcctPeriodTo(data) {
      this.resetValidator()
      this.resetMessages()
      this.reportForm.acctPeriodTo = data.acctPerMth + ' / ' + data.acctPerYr
      this.reportForm.acctPerMthTo = data.acctPerMth
      this.reportForm.acctPerYrTo = data.acctPerYr
      this.showAcctPeriodHelpListTo = false
    },
    doAssign(fieldName, obj) {
      switch (fieldName) {
        case 'interType':
          this.reportForm.interType = obj.finalSelectedItems.toString()
          this.showInterTypeHelpList = false
          break
      }
    },
    async doAssignIntermediaryType(Obj) {
      this.reportForm.interType = []
      this.reportForm.interType = Obj.finalSelectedItems.toString()
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
    this.$validator.extend('acctNoRangeFrom', {
      getMessage: (field, args) => {
        return field + ' must less than or equal To Account No.'
      },
      validate: (value, args) => {
        if (value > args) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('acctNoRangeTo', {
      getMessage: (field, args) => {
        return field + ' must greater than or equal From Account No.'
      },
      validate: (value, args) => {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    AcctPeriodHelpList,
    MultiIntermediaryTypeHelpList
  }
}
</script>

<style>

</style>
